import React from 'react'
import Header from './Header'
import Footer from './Footer'
import {Helmet} from "react-helmet";
import { ToastContainer  } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import  { Toaster } from 'react-hot-toast';

const Layout = ({children,title,description,author,keywords}) => {
  return (
    <div>
        <Helmet>
          <meta name="description" content={description} />
          <meta name="keywords" content={keywords} />
          <meta name="author" content={author} />


                <title>{title}</title>
               
            </Helmet>
        <Header/>
        <main style={{minHeight: "70vh"}}> 
        <ToastContainer/>
        <Toaster/>
        {children}
        </main>
        <Footer/>
  
    </div>
  )
}
Layout.defaultProps={
  title:'3Sixteen Shopping-Ecommerce',
  description:'Online Cloth shopping',
  keywords: "cloth,shopping,ecommerce",
  auther:"3Sixteen Clothing"
}

export default Layout
